<template>
  <div class="ams" v-click-outside="close">
    <button type="button" class="ams-toggle" @click="open = !open">
      <span class="ams-summary" :class="{ placeholder: !model.length }">{{ summary }}</span>
      <span class="ams-caret">▾</span>
    </button>
    <div v-if="open" class="ams-menu">
      <button v-for="opt in options" :key="opt" type="button" class="ams-opt"
              :class="{ on: model.includes(opt) }" @click="toggle(opt)">
        <span class="ams-check">{{ model.includes(opt) ? '✓' : '' }}</span>{{ opt }}
      </button>
    </div>
  </div>
</template>

<script setup>
/**
 * AltarMultiSelect — the Simple-tab dropdown with multiple selections. Curated
 * options only (the Advanced tab is where free-add lives), keeping the regular
 * user's flow to a few taps.
 */
import { ref, computed } from 'vue'

const props = defineProps({
  model: { type: Array, default: () => [] },
  options: { type: Array, default: () => [] },
  placeholder: { type: String, default: 'Choose…' },
})
const emit = defineEmits(['update'])
const open = ref(false)

const summary = computed(() =>
  props.model.length ? props.model.join(', ') : props.placeholder)

function toggle(opt) {
  emit('update', props.model.includes(opt)
    ? props.model.filter(o => o !== opt)
    : [...props.model, opt])
}
function close() { open.value = false }

// Lightweight click-outside without a global plugin.
const vClickOutside = {
  mounted(el, binding) {
    el._handler = (e) => { if (!el.contains(e.target)) binding.value() }
    document.addEventListener('click', el._handler, true)
  },
  unmounted(el) { document.removeEventListener('click', el._handler, true) },
}
</script>

<style scoped>
.ams { position: relative; margin-top: 5px; }
.ams-toggle { width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 8px;
  padding: 9px 11px; border-radius: 8px; border: 1px solid rgba(155,134,201,0.4); background: rgba(20,8,40,0.55);
  color: #e9dcff; font-size: 14px; font-family: inherit; cursor: pointer; text-align: left; }
.ams-summary { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ams-summary.placeholder { color: #7c6ba0; }
.ams-caret { color: #9b86c9; flex-shrink: 0; }
.ams-menu { position: absolute; z-index: 6; left: 0; right: 0; margin-top: 4px; max-height: 220px; overflow-y: auto;
  background: #1a0a2e; border: 1px solid rgba(102,51,153,0.4); border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.4); }
.ams-opt { display: flex; align-items: center; gap: 8px; width: 100%; text-align: left; padding: 8px 12px;
  background: none; border: none; color: #d8c9f5; font-size: 13px; cursor: pointer; font-family: inherit; }
.ams-opt:hover { background: rgba(102,51,153,0.25); color: #FFDFA3; }
.ams-opt.on { color: #f0d9a3; }
.ams-check { width: 14px; color: #f0d9a3; }
</style>
